import AlertDialog from '../AlertDialog';

import AddressWithLink from './AddressWithLink';

const StoreOutletDialog = ({ outlets, outletsDialogVisible, handleStoreDialog }) => (
  <AlertDialog
    title="Store Outlets"
    ariaLabel="Store outlets"
    isOpen={outletsDialogVisible}
    onDismiss={handleStoreDialog}
  >
    <table
      data-testid="outlets-table"
      className="table"
      css={`
        min-width: 60rem;
      `}
    >
      <thead>
        <tr>
          <th>Outlet</th>
          <th>Address</th>
          <th>Opening Hours</th>
          <th>Contact Number</th>
        </tr>
      </thead>
      <tbody>
        {outlets?.map((outlet) => {
          const { name, fullAddress, openingHours, contactInfo, lat, lng } = {
            ...outlet,
          };
          const { phoneNumber } = { ...contactInfo };

          return (
            <tr key={outlet.id}>
              <td>
                <strong>{name}</strong>
              </td>
              <td>
                {fullAddress && <AddressWithLink address={fullAddress} lat={lat} lng={lng} />}
              </td>
              <td>{openingHours?.legacyOpeningHours}</td>
              <td>{phoneNumber && <a href={`tel:${phoneNumber}`}>+65 {phoneNumber}</a>}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </AlertDialog>
);

export default StoreOutletDialog;
